import { Modal, Typography } from 'antd';
import React from 'react';
import { toast } from 'react-toastify';
import SuccessIcon from '../../../assets/images/success.svg';
import AlumlyButton from '../../../components/AlumlyButton';
import { ServiceNameEnum } from '../../../enums/serviceName';
import useServices from '../../../hooks/useServices';

export interface BoUserT {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  roleIds: string[];
  status: boolean
}
interface ConfirmCreateBoUserModalProps {
  boUser: BoUserT;
  handleClose: () => void;
  handleDialogClose: () => void;
  onSuccess:() => void;
  isOpen: boolean;

}
const ConfirmCreateBoUserModal
: React.FC<ConfirmCreateBoUserModalProps> = (props: ConfirmCreateBoUserModalProps) => {
  const {
    isOpen, handleClose, boUser, handleDialogClose, onSuccess,
  } = props;
  const { service: createBoUserService } = useServices(ServiceNameEnum.boUser.create);

  const onSubmit = async (): Promise<void> => {
    const { data, error } = await createBoUserService.post({
      email: boUser.email,
      password: boUser.password,
      firstName: boUser.firstName,
      lastName: boUser.lastName,
      roleIds: boUser.roleIds,
      username: boUser.email,
      isActive: boUser.status,

    });
    if (data) {
      onSuccess();
      handleClose();
      handleDialogClose();
      toast.success('Create bo-user successful');
    } else if (error) {
      handleClose();
      const errorMessage = error?.response.data.error.errors[0].message;
      toast.error(errorMessage);
      handleClose();
      handleDialogClose();
    }
  };

  return (
    <Modal
      open={isOpen}
      onCancel={handleClose}
      footer={null}
      centered
      width={600}
      styles={{ body: { textAlign: 'center' } }}
    >
      <div style={{ marginTop: 32 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <img src={SuccessIcon} alt="" style={{ width: '70px', height: '70px' }} />
        </div>
        <Typography.Title level={4} style={{ fontWeight: 'bold' }}>
          Are you sure you want to create user ?
        </Typography.Title>
      </div>
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        marginTop: 24,
        paddingTop: 16,
        paddingBottom: 24,
        backgroundColor: '#F4F6F8',
      }}
      >
        <AlumlyButton label="rxvWhite" width={150} onClick={handleClose}>Cancel</AlumlyButton>
        <div style={{ marginLeft: 16 }}>
          <AlumlyButton
            label="rxv"
            width={150}
            onClick={onSubmit}
          >
            Create
          </AlumlyButton>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmCreateBoUserModal;
